import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EmailNew"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M14.25 18H3L2.99745 6.67965L11.573 12.6167C11.6985 12.7035 11.8474 12.75 12 12.75C12.1526 12.75 12.3015 12.7035 12.427 12.6167L21 6.68152V13.5H22.5V6C22.4995 5.60234 22.3413 5.22112 22.0601 4.93993C21.7789 4.65874 21.3977 4.50054 21 4.5H3C2.60232 4.50046 2.22105 4.65864 1.93984 4.93984C1.65864 5.22105 1.50046 5.60232 1.5 6V18C1.50054 18.3977 1.65874 18.7789 1.93993 19.0601C2.22112 19.3413 2.60234 19.4995 3 19.5H14.25V18ZM19.3489 6L12 11.0878L4.65105 6H19.3489Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.5 21C21.1569 21 22.5 19.6569 22.5 18C22.5 16.3431 21.1569 15 19.5 15C17.8431 15 16.5 16.3431 16.5 18C16.5 19.6569 17.8431 21 19.5 21Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EmailNew.vue"]]);
